/** SoC UI colors: <20% red, <80% yellow, otherwise green (up to 100%). */
const SOC_COLORS = {
  red: {
    color: '#ff6b6b',
    border: 'rgba(255, 107, 107, 0.92)',
    fill: 'rgba(255, 107, 107, 0.12)',
    legend: 'linear-gradient(90deg, rgba(255, 107, 107, 0.95), rgba(255, 59, 92, 0.95))',
  },
  yellow: {
    color: '#f6c343',
    border: 'rgba(246, 195, 67, 0.92)',
    fill: 'rgba(246, 195, 67, 0.12)',
    legend: 'linear-gradient(90deg, rgba(246, 195, 67, 0.95), rgba(255, 166, 0, 0.95))',
  },
  green: {
    color: '#6ee7a0',
    border: 'rgba(110, 231, 160, 0.92)',
    fill: 'rgba(110, 231, 160, 0.12)',
    legend: 'linear-gradient(90deg, rgba(110, 231, 160, 0.95), rgba(82, 216, 138, 0.95))',
  },
};

export function getSocColors(soc) {
  const value = Number(soc);
  if (!Number.isFinite(value)) {
    return SOC_COLORS.green;
  }
  if (value < 20) {
    return SOC_COLORS.red;
  }
  if (value < 80) {
    return SOC_COLORS.yellow;
  }
  return SOC_COLORS.green;
}
